import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getServers(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_SERVERS_REQUESTED", "GET_SERVERS_SUCCESS", "GET_SERVERS_FAILED"],
        method: "POST",
        path: "admin/get_servers",
        body: data
    });
}

export function deleteServer(server_id){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.focus = true;
    data.target_server = {"server_id": server_id}; 
    appendTokenName(data);  
    return apiAction({
        types: ["DELETE_SERVERS_REQUESTED", "DELETE_SERVERS_SUCCESS", "DELETE_SERVERS_FAILED"],
        method: "POST",
        path: "admin/delete_server",
        body: data
    });
}

export function updateServer(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_server = userData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_SERVER_REQUESTED", "UPDATE_SERVER_SUCCESS", "UPDATE_SERVER_FAILED"],
        method: "POST",
        path: "admin/update_server",
        body: data
    });
}

export function setAgentPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_AGENT_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function destroyAgentKasms(server_id){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.focus = true;
    data.target_server = {"server_id": server_id};
    appendTokenName(data);
    return apiAction({
        types: ["DESTROY_AGENT_KASMS_REQUESTED", "DESTROY_AGENT_KASMS_SUCCESS", "DESTROY_AGENT_KASMS_FAILED"],
        method: "POST",
        path: "admin/destroy_agent_kasms",
        body: data
    });
}




// WEBPACK FOOTER //
// ./src/actions/actionServer.js